import { Link } from 'react-router-dom';
import { articles, hotTags } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function TrendingSidebar() {
  const trending = articles.filter((a) => a.isHot).slice(0, 5);

  return (
    <aside className="space-y-6">
      <div className="bg-background-100/70 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-fire-line text-accent-500"></i>
          </div>
          <h3 className="font-heading font-semibold text-foreground-900 text-sm">24小时热榜</h3>
        </div>
        <div className="space-y-1">
          {trending.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="flex items-start gap-2 py-2 border-b border-background-200/50 last:border-0 group cursor-pointer"
            >
              <span className={`font-heading font-bold text-sm flex-shrink-0 w-5 ${index < 3 ? 'text-accent-500' : 'text-foreground-400'}`}>
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                {article.title}
              </span>
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-background-100/70 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-hashtag text-primary-500"></i>
          </div>
          <h3 className="font-heading font-semibold text-foreground-900 text-sm">热门标签</h3>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {hotTags.map((tag) => (
            <span
              key={tag}
              className="px-2.5 py-1 rounded-full bg-background-200/70 text-foreground-600 text-xs hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>

      <div className="bg-background-100/70 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-thumb-up-line text-secondary-600"></i>
          </div>
          <h3 className="font-heading font-semibold text-foreground-900 text-sm">编辑推荐</h3>
        </div>
        <div className="space-y-2">
          {articles.slice(3, 6).map((article) => (
            <ArticleCard key={article.id} article={article} variant="compact" />
          ))}
        </div>
      </div>
    </aside>
  );
}